export const handleChangeDataModalEditMobileVerifyOne = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_EDIT_MOBILE_VERIFY_ONE', name, value
});